module.exports = __webpack_public_path__ + "static/1-6cc7be86a9a731d72f6f575d5302e679.jpg";